import React from 'react';
import { ErrorMessage,Field } from 'formik';
import Proptypes from 'prop-types';
import DatePickerComponent from '../datePicker/DatePickerComponent';
import { formErrorMessage } from './FormErrorMessage';

const FormikDatePicker = ({ name, ...props }) => (
  <Field name={name}>
    {({ field: { value }, form: { setFieldValue, touched, errors } }) => (
      <>
        <DatePickerComponent
          onChange={(date) => {
            setFieldValue(name, date);
          }}
          date={value ? new Date(value) : 'Select a Date'}
          isValid={touched[name] && !errors[name]}
          isInvalid={touched[name] && errors[name]}
          {...props}
        />
        <ErrorMessage name={name} render={formErrorMessage} />
      </>
    )}
  </Field>
);
FormikDatePicker.propTypes = {
  name: Proptypes.string.isRequired,
};
export default React.memo(FormikDatePicker);
